define(function (require, exports, module) {
    'use strict';

    var UploadFail = require('./UploadFail');

    /**
     * @constructor
     * @extends {UploadFail}
     * @param {Error} stack
     * @param {string} source
     */
    function LocalFileNotReadableFail(stack, source) {
        UploadFail.apply(this, arguments);
    }

    /**
     * @param {DOMException|FileError} error
     * @returns {boolean}
     */
    LocalFileNotReadableFail.isNotReadableError = function (error) {
        var isNotReadableError = false;

        if (window.DOMException && error instanceof DOMException) {
            // Chrome
            isNotReadableError = error.code === DOMException.NOT_READABLE_ERR || error.code === DOMException.NS_ERROR_FILE_ACCESS_DENIED;
        } else if (window.FileError && error instanceof FileError) {
            // Safari
            isNotReadableError = error.code === FileError.NOT_READABLE_ERR || error.code === FileError.NS_ERROR_FILE_ACCESS_DENIED;
        }

        return isNotReadableError;
    };

    LocalFileNotReadableFail.prototype = Object.assign(Object.create(UploadFail.prototype), {
        constructor: LocalFileNotReadableFail,
        className: 'LocalFileNotReadableFail',
        radarName: 'fail_{SOURCE}_local-file-not-readable',
        message: ['Файл не может быть прочитан, из-за проблем с правами доступа.', 'Возможно файл используется другой программой.'].join(
            ' '
        ),
    });

    module.exports = LocalFileNotReadableFail;
});
